<template>
  <a-modal v-model.trim="visible" width="1200px" centered>
    <template #title>
      <div class="pickup-record-modal-header">
        <div class="pickup-record-modal-header-title">
          {{ $t('租赁_录入提箱信息') }}
        </div>
        <div class="pickup-record-modal-header-extra">
          <a-steps v-model="step" size="small">
            <template v-for="item in steps">
              <a-step :title="item.title" disabled/>
            </template>
          </a-steps>
        </div>
      </div>
    </template>
    <template>
      <div class="pickup-steps-content">
        <!-- region 第1步 录入提箱信息 -->
        <div v-if="step === 0" class="pickup-record-modal-step-1">
          <div class="pickup-left">
            <div class="pickup-left-header">
              <div class="pickup-left-header-title">{{ $t('packingList') }}</div>
              <dol-upload :paramsData="importParams" :text="$t('uploadFiles')" serverType="1010" :show-upload-list="false" @finished="importPickUpRecord">
                <a-button class="pickup-left-btn" type="link">{{ $t('bulkImport') }}</a-button>
              </dol-upload>
              <a-button class="pickup-left-btn" type="link" @click="downloadTemplate">{{ $t('通用_下载导入模版') }}</a-button>
            </div>
            <div class="pickup-left-body">
              <template v-for="order in releaseOrderData">
                <div class="pickup-left-body-order">
                  <div class="pickup-left-info-number">
                    <span class="pickup-left-info-number-name">{{ $t('orderID') }}：</span>
                    <span>{{ order.SHEET_CODE }}</span>
                  </div>
                  <template v-for="releaseOrder in order.RELEASE_LIST">
                    <div class="pickup-left-box" :class="{active: currentReleaseOrder === releaseOrder}" @click="pickReleaseOrder(releaseOrder)">
                      <div class="pickup-left-box-header">
                        <div class="pickup-left-box-header-title">
                          {{ releaseOrder.RELEASE_SEND_CODE }}
                          <a-tag>{{ $dt(releaseOrder, 'BOX_SIZE_NAME') }}</a-tag>
                        </div>

                        <span class="pickup-left-box-header-count">{{ releaseOrder.COUNT }} / {{ releaseOrder.QTY }}</span>
                      </div>
                      <div class="pickup-left-box-content">
                        <div>
                          <span>{{ $dt(releaseOrder, 'SPACE_NAME') }}</span>
                          <div class="pickup-left-box-content-date">{{ $t('takeBoxIndate') }}：{{ releaseOrder.START_DATE }}-{{ releaseOrder.END_DATE }}</div>
                        </div>
<!--                        <dol-button>-->
<!--                          <a-icon type="download"/>-->
<!--                        </dol-button>-->
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div class="pickup-right" v-if="currentReleaseOrder">
            <div class="pickup-right-header">
              <span class="pickup-right-box-header-title">{{ currentReleaseOrder.RELEASE_ORDER_CODE }}</span>
              <span class="pickup-right-box-header-note">{{ $t('提示_请完善提箱信息') }}</span>
            </div>
            <template v-for="(pickItem, index) in pickUpData[currentReleaseOrder.RELEASE_ORDER_CODE]">
              <div class="pickup-right-box">
                <div class="pickup-right-box-header">
                  <div class="pickup-right-box-header-title">{{ $t('takeBoxInfo') }}{{ index + 1 }}</div>
                </div>
                <div>
                  <a-form-model :model="pickItem" :rules="pickRules">
                    <a-row :gutter="20">
                      <a-col :span="12">
                        <a-form-model-item :label="$t('takeBoxDate')" prop="PICKUP_DATE">
                          <dol-date v-model="pickItem.PICKUP_DATE" :disabled-date="v => $moment().endOf('day').isBefore(v)"/>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="12">
                        <a-form-model-item :label="$t('通用_箱号')" prop="BOX_NUMBER">
                          <a-input v-model="pickItem.BOX_NUMBER"/>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <dol-upload-img-list
                        v-model="pickItem.GUID_CODES"
                        :max="6"
                        :paramsData="uploadParams"
                        :placeholder="$t('pictureOfContainer')"
                        serverType="2009"
                    />
                  </a-form-model>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- endregion -->

        <!-- region 第2步 录入提箱信息 -->
        <div class="pickup-record-modal-step-2" v-else-if="step === 1">
          <template>
            <div>
              <a-collapse v-model="openCollapse" expandIconPosition="right">
                <template v-for="order in pickUpDataByOrder">
                  <a-collapse-panel class="pickup-collapse-panel" :key="order.SHEET_CODE">
                    <template #header>
                      <div class="pickup-collapse-panel-header">
                        {{$t('orderID')}}：{{ order.SHEET_CODE }}
                      </div>
                    </template>
                    <template>
                      <dol-list
                          :card-flag="false"
                          :pagination="false"
                          :columns="columns"
                          source="local"
                          :default-data="order.PICK_UP_LIST"
                          bordered
                          row-key="RELEASE_ORDER_CODE"
                      >
                        <template #PICKUP_IMAGE="field, record">
                          <dol-image-list-preview :image-list="record.PICKUP_IMAGE" width="60px" height="60px" />
                        </template>
                      </dol-list>
                    </template>
                  </a-collapse-panel>
                </template>
              </a-collapse>
            </div>
          </template>
        </div>
        <!-- endregion -->

        <!-- region 第3步 数据提交结果 -->
        <div v-else-if="step === 2" class="pickup-finish">
          <a-icon class="check-icon" type="check-circle" theme="filled"/>
          <div class="pickup-finish-state">{{$t('提示_提箱完成')}}</div>
          <div class="pickup-finish-info">{{ $t('提示_已完成提箱') }}【{{boxList.length}}】</div>
          <a-button class="pickup-finish-btn" type="primary" @click="close">{{$t('通用_完成')}}</a-button>
        </div>
        <!-- endregion -->
      </div>
    </template>
    <template #footer>
      <div class="steps-action">
        <div class="error-message">{{ errorMessage }}</div>
        <div class="button-panel">
          <template v-if="step === 0">
            <a-button type="primary" @click="next">{{ $t('通用_下一步') }}</a-button>
          </template>
          <template v-else-if="step === 1">
            <a-button @click="prev">{{ $t('上一步') }}</a-button>
            <a-button type="primary" @click="submitData">{{ $t('通用_确认提交') }}</a-button>
          </template>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
const langMap = {
  'zh': 10141001,
  'en': 10141002,
  'ru': 10141003,
};
export default {
  name: 'pickup-record',
  components: {},
  mixins: [],
  data () {
    return {
      visible: false,

      // 操作数据
      step: 0,
      boxList: [],
      pickUpData: {},
      openCollapse: [],
      currentReleaseOrder: null,
      loading: false,
      errorMessage: '',
    };
  },
  computed: {
    // region 界面展示信息
    steps () {
      return [
        { title: this.$t('租赁_录入提箱信息') },
        { title: this.$t('通用_确认信息') },
        { title: this.$t('提示_提箱完成') },
      ];
    },
    columns () {
      let columns = [];
      // columns.push({ dataIndex: 'MASTER_ID', title: '单据号' });
      columns.push({ dataIndex: 'RELEASE_SEND_CODE', width: '200px', title: this.$t('putBoxOrderNumber') });
      columns.push({ dataIndex: this.$kt('SPACE_NAME'), width: '200px', title: this.$t('通用_堆场') });
      columns.push({ dataIndex: 'BOX_NUMBER', width: '130px', title: this.$t('通用_箱号') });
      columns.push({ dataIndex: 'PICKUP_DATE', width: '110px', title: this.$t('takeBoxDate') });
      columns.push({ dataIndex: 'PICKUP_IMAGE', title: this.$t('takeBoxImg'), scopedSlots: { customRender: 'PICKUP_IMAGE' } });
      return columns;
    },
    pickRules () {
      return {
        PICKUP_DATE: [{ required: true, message: this.$t('通用_请选择提箱日期'), trigger: ['blur', 'change'] }],
        BOX_NUMBER: [{ required: true, message: this.$t('通用_请输入箱号'), trigger: ['blur', 'change'] }],
      };
    },
    uploadParams(){
      return {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021017",
        "TARGET_TYPE": "20071007",
        "TARGET_ID": "",
        "GUID_CODE":""
      };
    },
    importParams(){
      return {
        "IMPORT_TYPE": "20181022",
        "LANG_TYPE": langMap[this.$i18n.locale],
      };
    },
    // endregion

    // region 展示数据
    releaseOrderData () {
      const orderList = [];
      const orderMap = {}, releaseMap = {};
      this.boxList.forEach(box => {
        if (!orderMap[box.XB_SHEET_CODE]) {
          orderMap[box.XB_SHEET_CODE] = {
            SHEET_CODE: box.XB_SHEET_CODE,
            RELEASE_LIST: [],
          };
          orderList.push(orderMap[box.XB_SHEET_CODE]);
        }
        if (!releaseMap[box.XB_SHEET_CODE + box.XE_SHEET_CODE]) {
          releaseMap[box.XB_SHEET_CODE + box.XE_SHEET_CODE] = {
            XB_SHEET_CODE: box.XB_SHEET_CODE,
            RELEASE_ORDER_ID: box.XE_MASTER_ID,
            RELEASE_ORDER_FLOW_ID: box.XE_FLOW_ID,
            RELEASE_SEND_CODE: box.SEND_CODE,
            RELEASE_ORDER_CODE: box.XE_SHEET_CODE,
            BOX_SIZE_NAME: box.BOX_SIZE_NAME,
            BOX_SIZE_NAME_ENG: box.BOX_SIZE_NAME_ENG,
            BOX_SIZE_NAME_RUS: box.BOX_SIZE_NAME_RUS,
            SPACE_ID: box.XE_SPACE_ID,
            SPACE_NAME: box.XE_SPACE_NAME,
            SPACE_NAME_ENG: box.XE_SPACE_NAME_ENG,
            SPACE_NAME_RUS: box.XE_SPACE_NAME_RUS,
            COUNT: 0,
            QTY: 0,
            START_DATE: this.$moment(box.XE_BEGIN_DATE).format('YYYY-MM-DD'),
            END_DATE: this.$moment(box.XE_END_DATE).format('YYYY-MM-DD'),
          };
          orderMap[box.XB_SHEET_CODE].RELEASE_LIST.push(releaseMap[box.XB_SHEET_CODE + box.XE_SHEET_CODE]);
        }

        releaseMap[box.XB_SHEET_CODE + box.XE_SHEET_CODE].QTY++;
      });

      for(const key in this.pickUpData){
        this.pickUpData[key].forEach(item => {
          if(item.PICKUP_DATE && /^\w{4}\d{7}$/.test(item.BOX_NUMBER)){
            releaseMap[item.XB_SHEET_CODE + item.RELEASE_ORDER].COUNT++;
          }
        });
      }

      return orderList;
    },
    pickUpDataByOrder () {
      const data = [];
      this.releaseOrderData.forEach(order => {
        const orderData = { SHEET_CODE: order.SHEET_CODE, PICK_UP_LIST: [] };
        order.RELEASE_LIST.forEach(releaseOrder => {
          if(this.pickUpData[releaseOrder.RELEASE_ORDER_CODE]){
            this.pickUpData[releaseOrder.RELEASE_ORDER_CODE].forEach(item => {
              orderData.PICK_UP_LIST.push({
                RELEASE_ORDER_CODE: releaseOrder.RELEASE_ORDER_CODE,
                RELEASE_SEND_CODE: releaseOrder.RELEASE_SEND_CODE,
                SPACE_ID: releaseOrder.SPACE_ID,
                SPACE_NAME: releaseOrder.SPACE_NAME,
                SPACE_NAME_ENG: releaseOrder.SPACE_NAME_ENG,
                SPACE_NAME_RUS: releaseOrder.SPACE_NAME_RUS,
                BOX_NUMBER: item.BOX_NUMBER,
                PICKUP_DATE: item.PICKUP_DATE,
                PICKUP_IMAGE: item.GUID_CODES,
              });
            })
          }
        });
        data.push(orderData);
      });
      return data;
    },
    // endregion
  },
  methods: {
    open (boxList) {
      // 重置基础数据
      this.boxList = boxList;
      this.pickUpData = {};
      this.openCollapse = {};
      this.step = 0;
      this.currentReleaseOrder = null;
      this.loading = false;
      this.errorMessage = '';

      this.initPickUpData();
      this.pickReleaseOrder(this.releaseOrderData[0].RELEASE_LIST[0]);
      this.visible = true;
    },
    next () {
      // 校验是否已录入完整
      this.errorMessage = '';
      let errorReleaseOrder = null;
      this.releaseOrderData.find(order => {
        order.RELEASE_LIST.find(releaseOrder => {
          if(releaseOrder.COUNT < releaseOrder.QTY){
            errorReleaseOrder = releaseOrder;
            return true;
          }
        });
      });
      if(errorReleaseOrder){
        this.errorMessage = this.$t('租赁_信息录入不完整，或箱号格式不正确');
        this.pickReleaseOrder(errorReleaseOrder);
      }else{
        this.openCollapse = this.releaseOrderData.map(order => order.SHEET_CODE);
        this.step++;
      }
    },
    prev () {
      this.step--;
    },
    close () {
      this.$emit('refresh');
      this.visible = false;
    },

    // region 第一步
    initPickUpData(){
      this.releaseOrderData.forEach(order => {
        order.RELEASE_LIST.forEach(releaseOrder => {
          const releaseOrderPickData = [];
          for (let i = 0; i < releaseOrder.QTY; i++) {
            releaseOrderPickData.push({
              ORDER: releaseOrder.SHEET_CODE,
              XB_SHEET_CODE: releaseOrder.XB_SHEET_CODE,
              RELEASE_ORDER: releaseOrder.RELEASE_ORDER_CODE,
              BOX_NUMBER: '',
              PICKUP_DATE: '',
            });
          }
          this.$set(this.pickUpData, releaseOrder.RELEASE_ORDER_CODE, releaseOrderPickData);
        })
      })
    },
    pickReleaseOrder (releaseOrder) {
      this.currentReleaseOrder = releaseOrder;
    },
    downloadTemplate(){
      const exportData = [];
      exportData.push({
        EXPORT_TYPE: [{EXPORT_TYPE: '20181021'}],
        GET_HEAD: [],
        GET_FILTER: [],
        JSON_DATA: this.boxList.map(box => ({
          '通用_单据号': box.XB_SHEET_CODE,
          '租赁_系统放箱单号': box.XE_SHEET_CODE,
          'putBoxOrderNumber': box.SEND_CODE,
          'takeBoxDate': '',
          '通用_箱号': '',
        }))
      });
      this.$h5Api({
        type: '1005',
        data: exportData,
      }).then(({data}) => {
        this.$Dolphin.download(`${this.$t('租赁_录入提箱信息导入模板')}`, this.$Dolphin.path.filePath + data.value)
      }).finally(() => {
        this.exportLoading = false;
      })
    },
    importPickUpRecord(data){
      const orderMap = {};
      data.LIST.forEach(row => {
        const rowData = {
          XB_SHEET_CODE: row[this.$t('通用_单据号')],
          XE_SHEET_CODE: row[this.$t('租赁_系统放箱单号')],
          SEND_CODE: row[this.$t('putBoxOrderNumber')],
          PICKUP_DATE: row[this.$t('takeBoxDate')],
          BOX_NUMBER: row[this.$t('通用_箱号')],
        };
        if(!orderMap[rowData.XE_SHEET_CODE]){
          orderMap[rowData.XE_SHEET_CODE] = [];
        }
        orderMap[rowData.XE_SHEET_CODE].push(rowData);
      });

      for(const key in orderMap){
        orderMap[key].forEach((rowData, index) => {
          if(this.pickUpData[key]){
            this.pickUpData[key][index].PICKUP_DATE = rowData.PICKUP_DATE;
            this.pickUpData[key][index].BOX_NUMBER = rowData.BOX_NUMBER;
          }
        })
      }
    },
    // endregion

    // region 第二步
    submitData () {
      const submitData = [];
      this.releaseOrderData.forEach(order => {
        order.RELEASE_LIST.forEach(releaseOrder => {
          const data = {};
          data.OT_BOX_XF_MASTER = [{
            VOUCHER_ID: releaseOrder.RELEASE_ORDER_ID,
            SEND_DRIVER: '',
            SEND_PERSON: '',
            SEND_TRUCK: '',
            MEMO: '',
          }];
          data.OT_BOX_XF_DETAIL = [];
          if(this.pickUpData[releaseOrder.RELEASE_ORDER_CODE]){
            this.pickUpData[releaseOrder.RELEASE_ORDER_CODE].forEach(item => {
              data.OT_BOX_XF_DETAIL.push({
                BOX_CODE: item.BOX_NUMBER,
                TAKE_DATE: item.PICKUP_DATE,
                PARENT_FLOW_ID: releaseOrder.RELEASE_ORDER_FLOW_ID,
                GUID_CODES: item.GUID_CODES ? item.GUID_CODES.map(val => val.GUID_CODE).join(',') : '',
              });
            })
          }
          submitData.push(data);
        });
      });

      this.loading = true;
      this.$h5Api({
        type: '4027',
        data: submitData,
      }).then(({data}) => {
        this.step++;
        this.$message.info(String(this.$t('confirmationSuccessful')));
      }).finally(() => {
        this.loading = false;
      });
    },
    // endregion
  },
};
</script>

<style lang="scss">
.pickup-record-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;

  .pickup-record-modal-header-title {

  }

  .pickup-record-modal-header-extra {
    width: 55%;
  }
}

.pickup-steps-content {
  border-radius: 6px;
  min-height: 200px;
  text-align: center;
  height: 75vh;
  overflow: hidden;

  .pickup-record-modal-step-1 {
    display: flex;
    align-items: flex-start;
    height: 100%;
    overflow: hidden;
  }

  .pickup-left {
    display: flex;
    flex-direction: column;
    width: 38%;
    margin-right: 14px;
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;

    .pickup-left-header {
      display: flex;
      align-items: center;

      .pickup-left-header-title {
        flex: 1;
        font-weight: 600;
        color: #333333;
        text-align: left;
      }

      .pickup-left-btn {
        padding: 0 6px;
      }
    }

    .pickup-left-body {

      .pickup-left-body-order {
        margin: 16px 0 8px 0;

        .pickup-left-info-number {
          text-align: left;
          border-left: 4px solid #206BBA;

          .pickup-left-info-number-name {
            padding-left: 6px;
          }
        }

        .pickup-left-box {
          background-color: #F5F7F9;
          border: 1px solid #F5F7F9;
          padding: 16px 14px 14px 14px;
          margin-top: 10px;
          border-radius: 4px;
          cursor: pointer;

          .pickup-left-box-header {
            display: flex;
            align-items: center;

            .pickup-left-box-header-title {
              flex: 1;
              color: #333333;
              font-weight: 600;
              text-align: left;
            }

            .pickup-left-box-header-count {
              color: #333333;
              font-size: 16px;
              font-weight: 600;
            }
          }

          &.pickup-left-box:active, &.active {
            border: 1px solid #1F6CBA;
            background: #F0F6FB;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
          }

          .pickup-left-box-content {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            margin-top: 2px;
            text-align: left;

            .pickup-left-box-content-case {
              margin-left: 8px;
            }

            .pickup-left-box-content-date {
              margin-top: 6px;
            }
          }
        }
      }

    }
  }

  .pickup-right {
    width: 58%;
    padding-left: 14px;
    flex: 1;
    text-align: left;
    border-left: 1px solid #dddddd;
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;

    .pickup-right-header {
      display: flex;
      align-items: center;

      .pickup-right-box-header-title {
        color: #333333;
        font-weight: 600;
        line-height: 1;
      }

      .pickup-right-box-header-note {
        margin-left: 12px;
        font-size: 12px;
        color: #666666;
      }
    }

    .pickup-right-box {
      flex: 1;
      text-align: left;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E5E5E5;
      padding: 12px 16px;
      margin-top: 12px;

      .pickup-right-box-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;

        .pickup-right-box-header-title {
          color: #333333;
          font-weight: 600;
          margin-right: 12px;
        }

        .pickup-btn {
          color: #999999;
        }
      }

      &.pickup-right-box:hover {
        background: #F5F7F9;
      }

    }

  }

  .pickup-record-modal-step-2 {
    height: 100%;
    overflow-y: auto;
  }

  .pickup-collapse-panel {
    text-align: left;
  }

  .pickup-finish {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;

    .check-icon {
      font-size: 70px;
      color: #52c41a;
    }

    .pickup-finish-state {
      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 30px;
    }

    .pickup-finish-info {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 8px;
    }

    .pickup-finish-btn {
      margin-top: 30px;
      width: 80px;
    }
  }
}

.steps-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .error-message{
    color: red;
  }
}
</style>